import * as React from 'react';
import { Button } from '@cian/ui-kit';

interface IShowAllButtonProps {
  disabled?: boolean;
  loading?: boolean;
  onClick(): void;
}

export const ShowAllButton: React.FC<IShowAllButtonProps> = ({ disabled, loading, onClick }) => {
  return (
    <Button
      disabled={disabled}
      loading={loading}
      onClick={onClick}
      theme="fill_secondary"
      size="L"
      fullWidth
      data-testid="ShowAllButton"
    >
      Посмотреть все акции
    </Button>
  );
};
